import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from "@mui/material"
import { AttachementsUpload } from "../../../../shared_elements/components";
import { useState } from "react";
import { PermissionWrapper } from "../../../../wrappers";
import { setFileUploadDetails } from "../../../../shared_elements/actions";
import { useDispatch, useSelector } from "react-redux";
import { trackActivity } from "../../../../utils/mixpanel";
import { formatBytes } from "../../../../utils/fileUpload";

const LeaseAttachmentsCRU = ({ addEditAttachments,fileUpload, onToggleModal, params, getResponseBack }) => {
   const dispatch=useDispatch()
    const {storageDetails } = useSelector((state) => state.leases);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const handleFileChanges = (files) => {
        setUploadedFiles(files);
       dispatch(setFileUploadDetails({attachments:files}))
    }
const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Add Attachments`, page_type: page_type, })
    }
    return (
        <>
            <Dialog open={addEditAttachments.modal}
                className="add-lease-dialog"
                maxWidth="sm"
                fullWidth >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title" className='dialog-header'> Lease Attachments
                    {/* <PermissionWrapper extraProps={{ application: "lease_revamp", feature: 'headlines', operationType: ['U'] }}>
                        <Typography sx={{ fontSize: "10px", color: '#d32f2f' }}>{"Downloadable Link will be Valid for 30 min only "}</Typography>
                    </PermissionWrapper> */}
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2} direction="column">
                        <Grid size={{ md: 12, xs: 12 }}>
                            <Button size='small' variant='outlined' color='primary' sx={{ marginBottom: '10px' }}>{`Available Space ${formatBytes(storageDetails?.remaining_storage)}`}</Button>
                            <AttachementsUpload onFileChange={handleFileChanges} attachments={addEditAttachments?.data} remainingStorage={storageDetails?.remaining_storage} isNote={`"Acceptance certificate"`} />
                        </Grid>

                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button className="cancel-btn" variant="outlined" size="small" onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}>{!uploadedFiles.length ? "Close" : "Cancel"}</Button>
                    {!uploadedFiles.length ? null : <Button disabled={!uploadedFiles.length} variant="contained" className="btn-primary" size="small" onClick={() => { fileUpload(); onToggleModal(); handleItemClicked('Save Button') }}>SAVE</Button> }
                </DialogActions>
            </Dialog>
        </>
    )
}
export default LeaseAttachmentsCRU;